/* eslint-disable prettier/prettier */
import {StyleSheet} from 'react-native';
import colors from '../../../theme/colors';
import { defaultTheme } from '../../../theme/defaultTheme';
import fonts from '../../../theme/fonts';
const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: defaultTheme.backGroundColor,
	},
	headerText: {
		fontFamily: fonts.type.Krona_Regular,
		fontWeight: '400',
		color: colors.white,
		fontSize: 30,
	},
	refreshBtnStyle: {
		position:'absolute',
		right: 16,
		bottom: 4 + 16,
		zIndex: 10,
	}
});
export default styles;
